module.exports = __webpack_public_path__ + "static/media/deep_dive.5a1acd15.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/badges/deep_dive.png
// module id = 1065
// module chunks = 0